/* ==========================================================================
 # Block scripts
 # @source:  https://dev.to/darnocer/lazy-loading-responsive-youtube-video-with-image-thumbnail-fake-play-button-7l3
========================================================================== */

// selects the parent containers
const videosContainers = document.querySelectorAll(".video-container");

if( videosContainers.length > 0 ) {

  videosContainers.forEach( videoContainer => {
    // get the video ID
    const videoID = videoContainer.dataset.videoId;

    // When the parent container is clicked
    videoContainer.addEventListener("click", function () {
      // remove the image container
      const lazyLoadingChild = videoContainer.querySelector(".lazy-loading-content");

      videoContainer.removeChild(lazyLoadingChild);

      // create a new responsive video container
      const responsiveVideoContainer = document.createElement("div");

      // apply responsive classes from bootstrap
      responsiveVideoContainer.classList.add(
        "embed-responsive"
      );

      // create the iFrame with the video embed
      const videoIframe = document.createElement("iframe");

      videoIframe.classList.add("embed-responsive-item");

      videoIframe.src = `https://www.youtube.com/embed/${videoID}?autoplay=1`;

      videoIframe.setAttribute("allow", "autoplay");

      // add the iFrame to the video container
      responsiveVideoContainer.appendChild(videoIframe);

      // add the video container to the parent container
      videoContainer.appendChild(responsiveVideoContainer);
    });

  });

}
